<div class="inline">

  <ng-container *ngIf="workflowInstance.codeWorkflowStatut != 'end'">

    <p-slideMenu #menu [model]="nextStepItems"
                 [style]="{'width':'350px'}"
                 [menuWidth]="350"
                 appendTo="body" [popup]="true"></p-slideMenu>
    <yo-button
      *ngIf="play"
      buttonClass="cta-inner-secondary"
      [disabled]="!workflowSvc.canModifyCurrentStep(workflowInstance)"
      iconClass="fas fa-play"
      tooltip="Passer à une des étapes suivantes"
      (onClick)="menu.toggle($event)">
    </yo-button>

    <yo-button
      *ngIf="!play"
      iconPos="right"
      buttonClass="cta-edit-or-watch"
      label="Suivant"
      tooltip="Passer à une des étapes suivantes"
      iconClass="fas fa-angle-right"
      [disabled]="!workflowSvc.canModifyCurrentStep(workflowInstance)"
      (onClick)="menu.toggle($event)">
    </yo-button>


  </ng-container>


</div>

<p-dialog
  [dismissableMask]="false"
  header="CONFIRMATION DU PASSAGE EN COMMANDE"
  [contentStyle]="{'overflow':'visible'}"
  [responsive]="true"
  [modal]="true"
  [minY]="200"
  [style]="{'width':'800px'}"
  [(visible)]="displayDialogPassageCommande">

  <div class="card">

    <div class="card-body">
      <p>🗣️ ATTENTION, vous ne pourrez plus modifier votre liste de besoins après votre passage en commande.</p>
      <br/>
      <p>
        <i class="fas fa-arrow-right space"></i>{{lbdActifs}} article(s) sélectionné(s) dans votre liste de besoins.
      </p>
      <br/>
      <ng-container *ngIf="listeBesoinEnErreur">
        <p><i class="fas fa-exclamation-triangle danger-color space"></i><b>Votre liste de besoins a {{lbErreurs}}
          article(s) en erreur, veuillez le(s) corriger. </b></p>
        <p style="line-height: 35px;">
          <p-checkbox [(ngModel)]="continueWithErrorsToPassageCommande" binary="true"></p-checkbox>
          Continuer quand même. <em>Les articles en erreur ne seront pas pris en compte.</em>
        </p>

      </ng-container>
    </div>
  </div>

  <ng-template pTemplate="footer">

    <ng-container *ngIf="!listeBesoinEnErreur">
      <yo-button iconClass="fas fa-check" (onClick)="goToCommande(workflowInstance)"
                 label="PASSER EN COMMANDE"></yo-button>
    </ng-container>
    <ng-container *ngIf="listeBesoinEnErreur">
      <ng-container *ngIf="continueWithErrorsToPassageCommande">
        <yo-button iconClass="fas fa-check" (onClick)="goToCommande(workflowInstance)"
                   label="PASSER EN COMMANDE"></yo-button>
      </ng-container>
      <ng-container *ngIf="!continueWithErrorsToPassageCommande">
        <yo-button iconClass="fas fa-check" disabled="true" (onClick)="goToCommande(workflowInstance)"
                   label="PASSER EN COMMANDE"></yo-button>
      </ng-container>


    </ng-container>

    <yo-button iconClass="fas fa-close" (onClick)="displayDialogPassageCommande=false" label="ANNULER"
               buttonClass="cta-inner-delete"></yo-button>
  </ng-template>

</p-dialog>
